// extracted by mini-css-extract-plugin
module.exports = {"sidebar-toggle":"Sidebar_sidebar-toggle__HWa0U","logo":"Sidebar_logo__2_P-_","sidebar":"Sidebar_sidebar__2go77","isOpen":"Sidebar_isOpen__24fDS"};